import React from 'react';
import { TelegramLogo, Envelope } from '@phosphor-icons/react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import SupportCard from '../../components/SupportCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import '../../HelpCenter.css';

/**
 * Need Help? Category Page
 */
const Support = () => {
  const cards = [
    {
      title: 'Live Chat',
      description: 'Get instant answers directly via Telegram.',
      icon: TelegramLogo,
      href: 'https://t.me/wesplit_support_bot'
    },
    {
      title: 'Email Support',
      description: 'Send a detailed request. We reply within 48 hours.',
      icon: Envelope,
      href: 'mailto:vcharles@wesplit.io'
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Need Help?</h1>
            <p className="lp-section-subtitle">
              Choose your preferred way to reach our team.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {cards.map((card, index) => (
                <SupportCard
                  key={index}
                  title={card.title}
                  description={card.description}
                  icon={card.icon}
                  href={card.href}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Support;
